import React from 'react'
import { Box, Checkbox, FormControl, FormControlLabel, FormGroup, Typography } from '@mui/material'

import { AmenitiesStepProps } from '../types'

const AmenitiesStep: React.FC<AmenitiesStepProps> = ({ value, onChange }) => {
  const options = [
    'In-unit washer/dryer',
    'Parking space',
    'High-speed Wi-Fi',
    'Security systems',
    'Common study lounges',
    'Fitness center',
  ]

  const handleToggle = (opt: string) => {
    if (value.includes(opt)) {
      onChange(value.filter(v => v !== opt))
    } else {
      onChange([...value, opt])
    }
  }

  return (
    <Box className="flex flex-col gap-6">
      <Typography variant="h5" className="font-bold text-gray-900">
        What are your preferred amenities? (Select all that apply)
      </Typography>

      <FormControl>
        <FormGroup className="flex flex-col gap-2">
          {options.map(opt => (
            <FormControlLabel
              key={opt}
              value={opt}
              control={<Checkbox checked={value.includes(opt)} onChange={() => handleToggle(opt)} />}
              label={opt}
              className="text-base"
            />
          ))}
        </FormGroup>
      </FormControl>
    </Box>
  )
}

export default AmenitiesStep
